import React, { useEffect } from "react";
import StatsCounter from "../Common/StatsCounter";
import { statsData } from "../../data/statsData";
import ContactSection from "../Common/ContactSection";

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, {});

  return (
    <div className="contact">
        <div class="container-fluid page-header py-5">
            <div class="container text-center py-5">
                <h1 class="display-2 text-white mb-4 animated slideInDown">Contact</h1>
                <nav aria-label="breadcrumb animated slideInDown">
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item"><a href="#">Pages</a></li>
                        <li class="breadcrumb-item" aria-current="page">Contact</li>
                    </ol>
                </nav>
            </div>
        </div>

      <StatsCounter stats={statsData} />

        <ContactSection />
    </div>

 );
}

export default Contact;  